import { ApiPortfolioType } from '@/api'
import { PORTFOLIO_TYPE } from '@/constants'

import { ProgressContainer, SimpleModal } from '../../../../../components/core-v2'
import { SearchPortfolioState } from '../state/portfolio-slice'
import { ModelPortfolio } from '../types'
import { PortfolioFinder } from './finder'

type Props = {
  onChangeSearchTerm: (term: string) => void
  onClickBackToSearch: () => void
  onInspectPortfolio: (id: string) => void
  onSelectPortfolio: (portfolio: ModelPortfolio) => void
  onStopChoosingPortfolio: () => void
  portfolioType?: ApiPortfolioType
  state: SearchPortfolioState
}

export const ChoosePortfolioModal = ({
  onChangeSearchTerm,
  onClickBackToSearch,
  onInspectPortfolio,
  onSelectPortfolio,
  onStopChoosingPortfolio,
  portfolioType,
  state
}: Props) => {
  const title = portfolioType
    ? `Find a ${PORTFOLIO_TYPE[portfolioType].value} portfolio`
    : 'Find a portfolio'
  return (
    <SimpleModal>
      <ProgressContainer
        currentStep={state.status === 'finding' ? 1 : 2}
        numSteps={2}
        title={title}
        onClickClose={() => onStopChoosingPortfolio()}
      >
        <PortfolioFinder
          allAssetPerformance={state.allAssetPerformance}
          portfolioBeingInspected={state.portfolioBeingInspected}
          portfolioType={portfolioType}
          portfolios={state.filteredPortfolios}
          searchTerm={state.searchTerm}
          status={state.status}
          onChangeSearchTerm={term => onChangeSearchTerm(term)}
          onClickBackToSearch={onClickBackToSearch}
          onInspectPorfolio={id => onInspectPortfolio(id)}
          onSelectPortfolio={portfolio => onSelectPortfolio(portfolio)}
        />
      </ProgressContainer>
    </SimpleModal>
  )
}
